import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { LoggedInInfoService } from "../../../../services/loggedInInfo/logged-in-info.service";
import { OrganizationLogicService } from "../../../../services/organization-logic/organization-logic.service";
import {
  RnOrganizationPackagePoolsForListVM,
  RnOrganizationsProfileVM,
} from "../../../../services/rnapi2-service/models/models";
import { PackageConfigInfo } from "../package-config-info";
import { CollectionView } from "@mescius/wijmo";

@Component({
    selector: "app-direct-inventory-table",
    templateUrl: "./direct-inventory-table.component.html",
    styleUrls: ["./direct-inventory-table.component.scss"],
    standalone: false
})
export class DirectInventoryTableComponent {
  private orgLogicService = inject(OrganizationLogicService);
  private loggedInUserService = inject(LoggedInInfoService);

  @Input() Heading: string;
  @Input() Subtext: string;
  @Input() QuantityColumnHeading = "Seats";
  @Input() set PackageList(list: Array<RnOrganizationPackagePoolsForListVM>) {
    this.collectionView = new CollectionView(list);
  }
  @Input() Loading = false;
  @Input() set OrgProfile(profile: RnOrganizationsProfileVM) {
    this.orgProfile = profile;
    if (this.orgProfile) {
      this.getCanOpenPackagesAddons();
    }
  }
  @Input() set TopLevelOrgId(topLevelOrgId: number) {
    this.topLevelOrgId = topLevelOrgId;
  }

  get TopLevelOrgId(): number {
    return this.topLevelOrgId;
  }

  @Input() PkgConfigInfo: PackageConfigInfo;
  @Input() set IsAddOns(isAddOns: boolean) {
    this.isAddOns = isAddOns;
    if (this.orgProfile) {
      this.getCanOpenPackagesAddons();
    }
  }

  @Output() PackagePoolSelected =
    new EventEmitter<RnOrganizationPackagePoolsForListVM>();

  collectionView!: CollectionView<any>;
  isAddOns: boolean = false;
  canOpenPackagesAddons: boolean = false;

  public SelectPackage(orgPackPool: RnOrganizationPackagePoolsForListVM) {
    if (this.PackagePoolSelected) {
      this.PackagePoolSelected.emit(orgPackPool);
    }
  }

  private getCanOpenPackagesAddons() {
    const loggedInUser = this.loggedInUserService.GetLoggedInUser();
    if (!loggedInUser) {
      return;
    }
    const ASNRMALLPK = this.loggedInUserService.loggedInUserHasRights([
      "ASNRMALLPK",
    ]);
    const isInternal = loggedInUser.IsInternal();
    const loggedInUserOrg = this.loggedInUserService.GetLoggedInUserOrg();
    this.canOpenPackagesAddons = this.orgLogicService.CanOpenPackagesAddOns(
        ASNRMALLPK,
        isInternal,
        this.orgProfile,
        loggedInUserOrg,
    );
  }

  private orgProfile: RnOrganizationsProfileVM;
  private topLevelOrgId: number;
}
